import { render, staticRenderFns } from "./ProjectShareDialog.vue?vue&type=template&id=9b3fa612&scoped=true&"
import script from "./ProjectShareDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectShareDialog.vue?vue&type=style&index=0&id=9b3fa612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3fa612",
  null
  
)

export default component.exports